
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.402 3.2h243.2c1.77 0 3.199 1.433 3.199 3.198v179.204c0 1.765-1.43 3.199-3.2 3.199H6.403c-1.77 0-3.199-1.434-3.199-3.2V6.399c0-1.765 1.43-3.199 3.2-3.199zm0 0","fill":"none","stroke-width":"6.4","stroke":"#000"}}),_c('path',{attrs:{"d":"M232.805 20.398a4.401 4.401 0 11-8.8.002 4.401 4.401 0 018.8-.002zm0 0M232.8 38.8a4.398 4.398 0 11-8.796 0 4.401 4.401 0 014.398-4.402 4.401 4.401 0 014.399 4.403zm0 0M232.8 57.2a4.401 4.401 0 01-4.398 4.402 4.401 4.401 0 010-8.801 4.398 4.398 0 014.399 4.398zm0 0","fill":"#9ea6b3"}}),_c('path',{attrs:{"d":"M25.602 99.2h204.8a3.2 3.2 0 013.2 3.198v64a3.202 3.202 0 01-3.2 3.204h-204.8a3.202 3.202 0 01-3.2-3.204v-64a3.2 3.2 0 013.2-3.199zm0 0","fill":"#e0e2e6"}}),_c('path',{attrs:{"d":"M25.605 25.602h99.2a3.198 3.198 0 110 6.398h-99.2a3.2 3.2 0 110-6.398zm0 0"}}),_c('path',{attrs:{"d":"M25.602 44.797H124.8A3.202 3.202 0 01128.004 48v16c0 1.766-1.434 3.2-3.203 3.2H25.6a3.2 3.2 0 01-3.199-3.2V48a3.202 3.202 0 013.2-3.203zm0 0","fill":"#e0e2e6"}})])
          )
        }
      }
    